var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.459,
    cy: 7,
    r: 6.459,
    fill: "#FE4A5A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.805 7h7.302M6.46 3.35v7.301",
    stroke: "#fff",
    strokeWidth: 1.123,
    strokeMiterlimit: 10
  })));
}
export default SvgPlusCircle;